import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { strings, getCurrentLocale } from 'APP_ROOT/localization';
import RavenUtil from 'APP_ROOT/components/common/ravenUtil';
import MyQueryRenderer from "../MyQueryRenderer";
import moment from 'moment';
import ReactTable from 'react-table'; /* for the report tables */
import { csvFormat } from 'd3-dsv';
import 'react-table/react-table.css';

import { requestProfilesForIdentities } from 'APP_ROOT/data/identities/actions';
import ProfileImage from 'APP_ROOT/components/ProfileImage';
import ErrorMessage from 'APP_ROOT/components/ErrorMessage';
import LocationLabel from 'APP_ROOT/components/pages/dashboard/LocationLabel';

import MaintenanceMessage from '../MaintenanceMessage';
import LocationService from '../../../services/locationService';

const LEGACY_FONT_SIZE = 16;
const BASE_FONT_SIZE = 14;
const TEMPLATE_SCALE_FACTOR = BASE_FONT_SIZE/LEGACY_FONT_SIZE;

function toHHMMSS(sec_num) {

    var days   = Math.floor(sec_num / (3600 * 24)) + 1;
    var hours   = Math.floor(sec_num / 3600);
    var minutes = sec_num % 3600;
    var seconds = Math.floor(minutes % 60);
    minutes = Math.floor(minutes / 60);

    if (days > 3) return "" + days + " " + strings.days;

    if (hours   < 10) {hours   = "0"+hours;}
    if (minutes < 10) {minutes = "0"+minutes;}
    if (seconds < 10) {seconds = "0"+seconds;}

    if(hours === 0)
        return minutes+':'+seconds;
    else
        return hours+':'+minutes+':'+seconds;

}

function formatEndTime(startTime, endTime)
{
    var endFormated = endTime.format("hh:mm:ss a");
    if(startTime.format("MMM Do YYYY") == endTime.format("MMM Do YYYY"))
    {
        return endFormated;
    }

    var days = endTime.diff(startTime, 'days') + 1 ;

    var daysText;

    daysText = "+" + days + " " + (days === 1 ? strings.day : strings.days);

    return [
        endFormated,
        <br/>,
        daysText
    ];
}

function getRawData(resultSet)
{
    var rows = [];

    if('rawData' in resultSet)
    {
        rows = resultSet.rawData();
    }
    else
    {
        for(var i = 0; ; i++)
        {
            if(resultSet.hasOwnProperty(i.toString()))
            {
                rows = rows.concat(resultSet[i.toString()].rawData());
                continue;
            }
            else
            {
                break;
            }
        }
    }

    return rows;
}


function getDaysBetweenDates (start, end) {

    var now = start.clone(), dates = [];

    while (now.isSameOrBefore(end)) {
        dates.push(now.format('YYYY-MM-DD'));
        now.add(1, 'days');
    }

    return dates;

}

function parsePosition (wkt) {

    if(!wkt) return null;

    var regexstring = 'POINT\\((-?\\d+\\.\\d+) (-?\\d+\\.\\d+)\\)';

    // var re = new RegExp('POINT\((-?\d+\.\d+) (-?\d+\.\d+)\)', 'ig');
    var re = new RegExp(regexstring, 'ig');

    var pos = re.exec(wkt);

    if(pos && pos.length > 2)
    {
        return {
            'lat': pos[1],
            'lon': pos[2],
        };
    }
    return null;

}

class ReportsSection extends React.PureComponent {

    render() {

        const seg_filters = [{
            "dimension": "FactSegment2.type",
            "operator": "equals",
            "values": ['parked']
        } ];
        const event_filters = [{
            "dimension": "DimEventType.name",
            "operator": "equals",
            "values": ['EVENT_IDLING_STOPPED']
        } ];

        var basicQuery = null;
        var idleQuery = null;
        var lastSegmentQuery = null;

        basicQuery = {
                 "timezone": Intl.DateTimeFormat().resolvedOptions().timeZone,
                 "measures": [
                     "FactSegment2.durationInSeconds",
                     "FactGeofenceState.durationInSeconds",
                 ],
                 "timeDimensions": [
                     {
                         "dimension": "FactSegment2.filterTime",
                         "dateRange": [
                             moment(this.props.selectedDateRange[0]).format('YYYY-MM-DD'),
                             moment(this.props.selectedDateRange[1]).format('YYYY-MM-DD'),
                         ]
                     }
                 ],
                 "dimensions": [
                     "DimDriver.name",
                     "DimDriver.identityId",
                     "DimVehicle.name",
                     "DimVehicle.vin", // ADDED
                     "FactSegment2.segId",
                     "FactSegment2.type",
                     "FactSegment2.filterTime",
                     "FactSegment2.startTime",
                     "FactSegment2.endTime",
                     "FactSegment2.startPosition",
                     "FactSegment2.endPosition",
                     "DimCard.cardId",
                     "DimCard.type",
                     "DimCard.startLocationName",
                     "DimCard.endLocationName",
                     "DimRaven.uuid",
                     "DimGeofence.name",
                     "DimGeofence.description",
                 ],
                 "filters": seg_filters
             };

         idleQuery = {
                 "timezone": Intl.DateTimeFormat().resolvedOptions().timeZone,
                 "measures": [
                     "FactEvent.duration",
                 ],
                 "timeDimensions": [
                     {
                         "dimension": "FactEvent.timestamp",
                         "dateRange": [
                             moment(this.props.selectedDateRange[0]).format('YYYY-MM-DD'),
                             moment(this.props.selectedDateRange[1]).format('YYYY-MM-DD'),
                         ]
                     }
                 ],
                 "dimensions": [
                     "DimVehicle.name",
                     "DimVehicle.vin", // ADDED
                     "FactEvent.timestamp",
                     "FactEvent.position",
                     "DimCard.cardId",
                     "DimCard.type",
                     "DimCard.startLocationName",
                     "DimCard.endLocationName",
                     "DimRaven.uuid",
                     "DimGeofence.name",
                     "DimGeofence.description",
                 ],
                 "filters": event_filters
             };

        if(moment(this.props.selectedDateRange[1]).format('YYYY-MM-DD') === moment().format("YYYY-MM-DD"))
        {
            lastSegmentQuery = {
                "timezone": Intl.DateTimeFormat().resolvedOptions().timeZone,
                "timeDimensions": [
                    {
                        "dimension": "LatestRavenSegment.endTime",
                        "dateRange": [
                            '2018-01-01', // Hardcode the start time, only use end time
                            moment().format('YYYY-MM-DD'), // Today
                        ]
                    }
                ],
                "dimensions": [
                    "LatestRavenSegment.endTime",
                    "LatestRavenSegment.type",
                    "LatestRavenSegment.segId",
                    "LatestRavenSegment.endPosition",
                    "LatestRavenEvent.timestamp",
                    "DimEventType.name",
                    "DimRaven.uuid",
                    "DimRaven.enclosureSerialNo",
                    "DimRaven.imei",
                    "DimRaven.iccid",
                    "DimRaven.ravenExternalId",
                    "DimRaven.activationTime",
                    "DimVehicle.name",
                    "DimVehicle.vin", // ADDED
                    "DimDriver.name",
                    "DimDriver.identityId",
                ],
                "order": {
                    "DimRaven.enclosureSerialNo": 'asc',
                },
            };
        }

        var queries = [];

        var days = getDaysBetweenDates(moment(this.props.selectedDateRange[0]),
                moment(this.props.selectedDateRange[1]));

        basicQuery.limit = 9000;
        idleQuery.limit = 9000;

        for(var i = 0; i < days.length; i++)
        {

            let minday = ""+days[i]+"T00:00:00";
            let maxday = ""+days[i]+"T23:59:59";
            if(i < (days.length - 1))
            {
                maxday = ""+days[i+1]+"T00:00:00";
            }

            basicQuery.timeDimensions = [ 
                            {
                                "dimension": "FactSegment2.filterTime",
                                "dateRange": [ minday, maxday ]
                            }
                ];
            idleQuery.timeDimensions = [ 
                            {
                                "dimension": "FactEvent.timestamp",
                                "dateRange": [ minday, maxday ]
                            }
                ];

            switch(this.props.showDrivingParking) {
            case 'parked':
                queries.push({...basicQuery});
                if(lastSegmentQuery) queries.push(lastSegmentQuery);
                break;
            case 'idling':
                queries.push({...idleQuery});
                break;
            case 'both':
                queries.push({...basicQuery});
                queries.push({...idleQuery});
                if(lastSegmentQuery) queries.push(lastSegmentQuery);
                break;
            default:
                break;

            }
        }

        if(queries.length > 0)
        {
            return (
                <MyQueryRenderer
                    user={this.props.user}
                    cubejsApi={this.props.cubejsApi}
                    queries={queries}
                    render={this.renderChart(basicQuery, ConnectedReportTable, this.props)}
                />
            );
        }
        else
        {
            return ( <div>{strings.app_an_error_occurred} </div>);
        }

    }

    renderChart = (myLastQuery, Component, props) => ({ resultSet, error, loadingState, ...otherProps }) => {
        if (error) {
            return this.renderError(error);
        } else if(resultSet) {
            return (
                <Component
                    {...otherProps}
                    stage={props.user.stage}
                    groupBy={props.groupBy}
                    unitOfMeasure={props.unitOfMeasure}
                    features={props.features}
                    resultSet={resultSet}
                    loadingState={loadingState}
                    limitTo={props.limitTo}
                    limitToFilteredResources={props.limitToFilteredResources}
                />
            );
        } else {
            return <div>{strings.loading}</div>;
        }
    };

    renderError = error => {
        if(error.message && error.message.match(/maintenance/i)) {
            return <MaintenanceMessage message={error.message} />;
        } else {
            return <ErrorMessage error={error} />;
        }
    }
}

class ReportTable extends React.PureComponent {
    state = {
        exportURI: null
    };
    
    componentDidMount() {
        this.fetchIdentities();
    }

    componentDidUpdate() {
        this.fetchIdentities();
    }

    fetchIdentities = () => {
        if( this.props.features.facial_recognition )
        {   
            const identityIds = new Set();
            const rows = getRawData(this.props.resultSet);
            rows.forEach(r => {
                if (r['DimDriver.identityId']) identityIds.add(r['DimDriver.identityId']);
            });
            this.props.dispatch(requestProfilesForIdentities(this.props.stage, Array.from(identityIds)));
        }
    }


    getDimensionColumn = (name, field, overrides = {}) => {
        return ({
            Header: name,
            accessor: d => d[field],
            id: field,
            maxWidth: 220 * TEMPLATE_SCALE_FACTOR,
            ...overrides
        });
    };

    generateExportURI = (columns, rawRows) => {
        const outputRows = rawRows.map(row => {
            const outRow = {};
            columns.forEach(col => {
                if((col.show || col.show === undefined || col.export)
                    && (col.export || col.export === undefined)) {
                    if(col.exportAccessor) {
                        outRow[col.Header] = (typeof col.exportAccessor === 'string' ? row[col.exportAccessor] : col.exportAccessor(row));
                    } else {
                        outRow[col.Header] = (typeof col.accessor === 'string' ? row[col.accessor] : col.accessor(row));
                    }
                }
            });
            return outRow;
        });
        const BOM='\uFEFF';
        return `data:text/csv;charset=utf-8,${BOM}${encodeURIComponent(csvFormat(outputRows))}`;
    }

    /* bundle aggregate values in a single value (string) such that they can be separated during render (in "Aggregated")*/
    generateAggregatedToPreserveIndividualValues (valuesArray) {
        return JSON.stringify(valuesArray); // TODO values are actually single items, what am I missing here?
    }

    /* separates the values bundled in a single string (in generateAggregatedToPreserveIndividualValues) and return the array of parsed values to be rendered */
    getValuesArrayFromAggregated (aggregatedRowValue) {
        if(aggregatedRowValue === null || aggregatedRowValue === undefined) return [];
        if(Array.isArray(aggregatedRowValue)) return aggregatedRowValue.filter(v => v !== null && v !== undefined);
        try {
            const parsed = JSON.parse(aggregatedRowValue);
            if(Array.isArray(parsed)) {
                return parsed.filter(v => v !== null && v !== undefined);
            }
            return [parsed];
        } catch(e) {
            return [aggregatedRowValue];
        }
    }

    getIdentityId = row => {
        if (row['DimDriver.identityId']) {
            return row['DimDriver.identityId'];
        }
        if (row._subRows && row._subRows[0]) {
            return this.getIdentityId(row._subRows[0]);
        }
        return null;
    }

    async enrichRowsWithAddresses(rows) {
            return Promise.all(rows.map(async (row) => {
                const start = row['FactSegment2.startPosition'];
    
                if (start?.lat && start?.lon) {
                    row.startAddress = await LocationService.reverseGeocode(start.lat, start.lon);
                }
    
                return row;
            }));
    }
    
        generateCSV = async (columns, rows) => {
            const enrichedRows = await this.enrichRowsWithAddresses(rows);
            const uri = this.generateExportURI(columns, enrichedRows);
            this.setState({ exportURI: uri });
        };

    render() {
        const { resultSet, stage } = this.props;

        this.units = 0;
        this.unitsString = '(mi)';

        if(this.props.unitOfMeasure === 'METRIC')
        {
            // Units string defaults to miles
            this.units = 1;
            this.unitsString = '(km)';
        }

        var pivots = [];
        var dims = [];
        var sort = [];

        if(this.props.groupBy === "vehicle")
        {
            pivots.push('DimVehicle.name');
            dims.push(this.getDimensionColumn(strings.reports_header_vehicle,'DimVehicle.name'));
            sort.push({id:'DimVehicle.name', desc: false});
        }
        else if(this.props.groupBy === "driver")
        {
            pivots.push('DimDriver.name');
            dims.push(this.getDimensionColumn(strings.reports_header_driver,'DimDriver.name', {
                Pivot: cellInfo => {
                    const identityId = this.getIdentityId(cellInfo.row);
                    const name = cellInfo.value;
                    const classes = cellInfo.isExpanded === undefined || cellInfo.isExpanded === false ? "rt-expander" : "rt-expander -open";
                    // TODO: no need to replace name conditionally with strings.unknown here if we group by identityId
                    return (
                        <ProfileImage
                            identityId={identityId}
                            caption={name.startsWith(strings.unknown) ? strings.unknown : name}
                            stage={stage}
                            imgSize='96px'
                            expander={true}
                            expanderClass={classes}
                        />
                    );
                },
            }));
            sort.push({id:'DimDriver.name', desc: false});
        }
        else if(this.props.groupBy === "vehicle,driver")
        {
            pivots.push('DimVehicle.name');
            pivots.push('DimDriver.name');
            dims.push(this.getDimensionColumn(strings.reports_header_vehicle,'DimVehicle.name'));
            dims.push(this.getDimensionColumn(strings.reports_header_driver,'DimDriver.name', {
                className: 'aggregate-list',
                Pivot: cellInfo => {
                    const identityId = this.getIdentityId(cellInfo.row);
                    const name = cellInfo.value;
                    const classes = cellInfo.isExpanded === undefined || cellInfo.isExpanded === false ? "rt-expander" : "rt-expander -open";
                    return (
                        <ProfileImage
                            identityId={identityId}
                            caption={name.startsWith(strings.unknown) ? strings.unknown : name}
                            stage={stage}
                            imgSize='64px'
                            expander={true}
                            expanderClass={classes}
                        />
                    );
                },
                aggregate: vals => {
                    /* TODO: using custom aggregate to sanitize strings.unknowns, but it would be nice if this could be avoided */
                    if(vals.length <= 0)
                    {
                        return null;
                    }
                    var myset = new Set();

                    vals.forEach(x => {

                        if(x.startsWith(strings.unknown)) // TODO: This will prevent users from having custom names starting with strings.unknown (e.g. "Unknown Soldier" (shrug, best I could think of)
                        {
                            myset.add(strings.unknown);
                        }
                        else
                        {
                            myset.add(x);
                        }
                    });

                    var result = [];

                    myset.forEach( (it) => {
                        result.push(it);
                    });
                    return this.generateAggregatedToPreserveIndividualValues(result);
                },
                Aggregated: row => {

                    const values = this.getValuesArrayFromAggregated(row.value);

                    return (  /* mimicking default ReactTable <span> rendering (for example, groupBy "driver,vehicle" below renders using <span> since we don't custom aggregate */
                        <span>
                            {values.map((value, index) => {
                                return  <span key={index}>
                                    {value}
                                    {index === values.length - 1 ? "" : ","}
                                </span>
                            })}
                        </span>
                    )
                }
            }));
            sort.push({id:'DimVehicle.name', desc: false});
            sort.push({id:'DimDriver.name', desc: false});
        }
        else if(this.props.groupBy === "driver,vehicle")
        {
            pivots.push('DimDriver.name');
            pivots.push('DimVehicle.name');
            dims.push(this.getDimensionColumn(strings.reports_header_driver,'DimDriver.name', {
                className: 'aggregate-list',
                Pivot: cellInfo => {
                    const identityId = this.getIdentityId(cellInfo.row);
                    const name = cellInfo.value;
                    const classes = cellInfo.isExpanded === undefined || cellInfo.isExpanded === false ? "rt-expander" : "rt-expander -open";
                    return (
                        <ProfileImage
                            identityId={identityId}
                            caption={name.startsWith(strings.unknown) ? strings.unknown : name}
                            stage={stage}
                            expander={true}
                            expanderClass={classes}
                            imgSize='96px'
                        />
                    );
                },
            }));
            dims.push(this.getDimensionColumn(strings.reports_header_vehicle,'DimVehicle.name'));
            sort.push({id:'DimDriver.name', desc: false});
            sort.push({id:'DimVehicle.name', desc: false});
        }
        else
        {
            pivots.push('DimVehicle.name');
            dims.push(this.getDimensionColumn(strings.reports_header_vehicle,'DimVehicle.name'));
            sort.push({id:'DimVehicle.name', desc: false});
        }

        // VIN column with aggregation collapse like Raven/DTC reports
        dims.push(this.getDimensionColumn(strings.reports_header_vin,'DimVehicle.vin', {
            aggregate: vals => {
                if(!vals || vals.length === 0) return null;
                const set = new Set();
                vals.forEach(v => { if(v) set.add(v); });
                return this.generateAggregatedToPreserveIndividualValues(Array.from(set));
            },
            Aggregated: row => {
                if(!row || !row.value) return null;
                const values = this.getValuesArrayFromAggregated(row.value);
                if(!values) return null;
                return (
                    <span>
                        {values.map((value, index) => (
                            <span key={index}>{value}{index === values.length - 1 ? '' : ','}</span>
                        ))}
                    </span>
                );
            },
        }));

        const columns = dims.concat([
            {   
                accessor: d => d['DimDriver.identityId'],
                id: 'DimDriver.identityId',
                show: false,
                filterable: false,
            },
            {
                Header: strings.reports_header_date,
                className: 'aggregate-list',
                accessor: d => d['FactSegment2.startTime'],
                id: 'FactSegment2.startTime',
                maxWidth: 120 * TEMPLATE_SCALE_FACTOR,
                Cell: x => <div> { x.value ? moment.utc(x.value).local().format("MMM Do YYYY") : "-" } </div>,
                PivotValue: x => <div> { x.value ? moment.utc(x.value).format("MMM Do YYYY") : "-" } ({ x.subRows.length })</div>,
                aggregate: vals => {
                    if(vals.length <= 0)
                    {
                        return null;
                    }
                    var min = vals[0];
                    var max = vals[0];
                    vals.forEach(x => {
                        if(Array.isArray(x))
                        {
                            if(min > x[0]) min = x[0];
                            if(max < x[1]) max = x[1];
                        }
                        else
                        {
                            if(min > x) min = x;
                            if(max < x) max = x;
                        }

                    });
                    if(min === max)
                        return min;
                    return [min, max];
                },
                Aggregated: (x) => {
                    /* mimicking default ReactTable <span> rendering (for example, groupBy "driver,vehicle" above renders using <span> since we don't custom aggregate */
                    return x.value && x.value.length === 2 ? (
                        <span>
                            <span>{moment.utc(x.value[0]).local().format("MMM Do YYYY")} - </span>
                            <span>{ moment.utc(x.value[1]).local().format("MMM Do YYYY") }</span>
                        </span>
                    ) : (
                        <span>
                            { moment.utc(x).local().format("MMM Do YYYY") }
                        </span>
                    );
                },
                filterable: false,
            },



            {
                Header: strings.reports_header_type,
                Cell: d => {
                    if(d.value === "idling")
                        return (<img className="icon-idling" src="/svg/icon-idling-status.svg" alt="Idling" title={strings.status_idling} />); 
                    else if(d.value === "parked_short")
                        return (<img src="/images/icon-parked-up-to-1-hr_h144.png" className="icon-trip-type parked"></img>);
                    else
                        return (<img src="/images/icon-parked_h144.png" className="icon-trip-type parked"></img>);
                    },
                accessor: d => d['FactSegment2.type'],
                exportAccessor: d => d['FactSegment2.type'] === "parked" || d['FactSegment2.type'] === "parked_short" ? "parked" : "idling",
                id: 'DimCard.type',
                maxWidth: 50 * TEMPLATE_SCALE_FACTOR,
                aggregate: vals => { return vals.reduce((total, curVal) => { if( total === "both") return total; if( total === "idling" && curVal.includes("parked")) return "both"; if( total.includes("parked") && curVal === "idling") return "both"; return curVal; } ) },
                Aggregated: d => {
                    if(d.value === "both")
                        return (
                            <div style={{ position:"relative"}}>
                                <img style={{position: "relative", top:0, left:0}} src="/images/icon-parked_h144.png" className="icon-trip-type parked"></img> 
                                <img style={{position: "absolute", bottom:"-0.42857142857em", right:"-0.42857142857rem", width:"1.33333333333rem", height:"1.33333333333rem"}} className="icon-idling" src="/svg/icon-idling-status.svg" alt="Idling" title={strings.status_idling} /> 
                            </div>
                        );
                    else if(d.value === "idling")
                        return ( <img className="icon-idling" src="/svg/icon-idling-status.svg" alt="Idling" title={strings.status_idling} /> );
                    else
                        return (<img src="/images/icon-parked_h144.png" className="icon-trip-type parked"></img>);
                    },
                filterable: false,
            },
            {
                Header: strings.reports_header_start_time,
                Cell: x => <div title= {moment.utc(x.value).local().format("LLLL")}> { moment.utc(x.value).local().format("hh:mm:ss a") } </div>,
                accessor: d => d['FactSegment2.startTime'],
                aggregate: vals => vals.reduce((total, curVal) => { return moment(total) > moment(curVal) ? total : curVal }),
                id: 'starttime',
                Aggregated: d => null,
                filterable: false,
                // Start/End
            },
            {
                Header: strings.reports_header_end_time,
                Cell: x => <div title= {moment.utc(x.value).local().format("LLLL")}> { formatEndTime( moment.utc(x.original['FactSegment2.startTime']).local(), moment.utc(x.value).local()) } </div>,
                accessor: d => d['FactSegment2.endTime'],
                aggregate: vals => vals.reduce((total, curVal) => { return moment(total) < moment(curVal) ? total : curVal }),
                id: 'endtime',
                Aggregated: d => null,
                filterable: false,
                // Start/End
            },
            {
                Header: strings.reports_header_parked_duration,
                Cell: d => (<div>{ toHHMMSS(d.value) }</div>),
                accessor: d => d['FactSegment2.parkedDuration'],
                id: 'FactSegment2.parkedDuration',
                aggregate: vals => vals.reduce((it, acc) => acc + it, 0),
                Aggregated: d => (<div>{ toHHMMSS(d.value) }</div>),
                filterable: false,
            },
            {
                Header: strings.reports_header_idling_duration,
                Cell: d => (<div>{ toHHMMSS(d.value) }</div>),
                accessor: d => d['FactSegment2.idlingDuration'],
                id: 'FactSegment2.idlingDuration',
                aggregate: vals => vals.reduce((it, acc) => acc + it, 0),
                Aggregated: d => (<div>{ toHHMMSS(d.value) }</div>),
                filterable: false,
            },
            {
                Header: strings.reports_header_location,
                Cell: (d) => { if(d.value && d.value.lat) return <LocationLabel withStreetNumber={true} addMapLink={true} location={d.value}/>; 
                    return null;},

                accessor: d => d['FactSegment2.startPosition'],
                exportAccessor: d => d.startAddress || '',
                id: 'FactSegment2.startPosition',
                aggregate: vals => { return vals.find((curVal) => { return curVal } )},
                Aggregated: d => null,
                filterable: false,
                // Start/End
            },
            {
                Header: strings.reports_header_geofences,
                className: 'aggregate-list',
                Cell: ({ value }) => (<span>{value && Array.from(value).join(", ")}</span>),
                accessor: d => d.geofences,
                aggregate: vals => {
                    if(vals.length <= 0)
                    {
                        return [];
                    }
                    var myset = new Set();

                    vals.forEach(x => {
                        x.forEach(y => {
                            myset.add(y);
                        });
                    });

                    return Array.from(myset);

                },
                Aggregated: row => {

                    return (  /* mimicking default ReactTable <span> rendering (for example, groupBy "driver,vehicle" below renders using <span> since we don't custom aggregate */
                        <span>
                            {row.value.map((value, index) => {
                                return  <span key={index}>
                                    {value}
                                    {index === (row.value.length - 1) ? "" : ","}
                                </span>
                            })}
                        </span>
                    )
                },
                id: 'DimGeofence.name',
                filterMethod: (filter, row) => {
                    var found = false;

                    var needle = filter.value.toLowerCase();

                    row[filter.id].forEach(x => {

                        var haystack = x.toLowerCase();
                        if(haystack.contains(needle)) found = true;
                    });

                    return found;
                },
                export: false
            },
            {
                Header: strings.reports_header_details,
                id: 'url',
                accessor: d => {
                    return d['DimCard.cardId'] && d['DimRaven.uuid'] ? d['DimRaven.uuid'] + "/" + d['DimCard.cardId'] : null;
                },
                maxWidth: 100 * TEMPLATE_SCALE_FACTOR,
                aggregate: vals => null,
                Cell: d => d.value ? <a href={d.original._historyUrlOverride || `/${getCurrentLocale()}/stats/history/${d.value}`} target="_blank" rel="noopener noreferrer">{strings.action_details}</a> : null,
                export: false,
                filterable: false,
            },
        ]);

        const rows = this.props.limitToFilteredResources(getRawData(resultSet), this.props.limitTo);

        // Roll up the rows (segments and idle events) into a single dataset.  Need to amalgamate geofence and other data too
        // obj holds all cards in a 'data' variable, keyed on unique identifier (segid or event ts)
        const cards = rows.reduce( (obj, row) => {

            var recordid = null;
            if(row['FactSegment2.segId'])
            {
                recordid = `${row['DimRaven.uuid']}.${row['FactSegment2.segId']}`;
            }
            else if(row["LatestRavenSegment.endTime"])
            {
                if(row["LatestRavenSegment.type"] === "driving")
                {
                    recordid = `${row['DimRaven.uuid']}.last` ;
                }
                else
                {
                    // Ignore the last parked segment (vehicle is driving)
                    return obj;
                }
            }
            else
            {
                recordid = `${row['DimRaven.uuid']}.${row['FactEvent.timestamp']}` ;
            }

            var curcard = {
            };

            if(row['DimVehicle.name'] === null)
            {
                console.error('DimVehicle.name is null. This is NOT supposed to happen.');
                row['DimVehicle.name'] = strings.unknown;
            }
            if(!row['DimDriver.name'])
            {   
                row['DimDriver.name'] = strings.unknown;
            }


            // If this record already exists, add geofences to it
            if(obj.data[recordid])
            {
                curcard = obj.data[recordid];

                // Add to the sets
                if(row['DimGeofence.name']) curcard.geofences.add(row['DimGeofence.name']);
            }
            else
            {
                
                curcard = {...row};

                curcard.geofences = new Set();

                if(row["LatestRavenSegment.endTime"])
                {
                    // Special case for last segment
                    curcard['FactSegment2.type'] = "parked";

                    var seconds = moment().diff(moment.utc(row['LatestRavenSegment.endTime']).toDate(), 'seconds');

                    curcard['FactSegment2.parkedDuration'] = seconds;
                    curcard['FactSegment2.idlingDuration'] = 0;
                    curcard['FactSegment2.startPosition'] = parsePosition(row['LatestRavenSegment.endPosition']);
                    curcard['FactSegment2.startTime'] = moment.utc(row['LatestRavenSegment.endTime']).toDate();

                }
                else
                {

                    // Add to the sets
                    if(row['DimGeofence.name']) curcard.geofences.add(row['DimGeofence.name']);

                    // Convert from event record to segment record
                    if(row['FactEvent.timestamp']) {
                        curcard['FactSegment2.type'] = 'idling';
                        curcard['FactSegment2.endTime'] = row['FactEvent.timestamp'];
                        curcard['FactSegment2.startTime'] = moment.utc(row['FactEvent.timestamp']).subtract(row['FactEvent.duration'], 'second').toDate();
                        curcard['FactSegment2.idlingDuration'] = row['FactEvent.duration'];
                        curcard['FactSegment2.parkedDuration'] = 0;
                        curcard['FactSegment2.startPosition'] = parsePosition(row['FactEvent.position']);
                    }
                    else
                    {
                        curcard['FactSegment2.type'] = row['FactSegment2.durationInSeconds'] < 3600 ? "parked_short" : "parked";
                        curcard['FactSegment2.parkedDuration'] = row['FactSegment2.durationInSeconds'];
                        curcard['FactSegment2.idlingDuration'] = 0;
                        curcard['FactSegment2.startPosition'] = parsePosition(row['FactSegment2.startPosition']);
                        curcard['FactSegment2.startTime'] = moment.utc(row['FactSegment2.startTime']).toDate();
                    }
                }
            }

            // apply rollup to our reduce object
            obj.data[recordid] = curcard;

            // reverse lookup set
            obj.indexes.add(recordid);

            return obj;

        }, { data: {}, indexes: new Set() });

        const finalcards = [];
        cards.indexes.forEach( (it) => {
            var curcard = cards.data[it];

            curcard['DimGeofence.name'] = Array.from(curcard.geofences).join();

            finalcards.push(curcard);
        });

        if(!finalcards || finalcards.length <= 0)
        {
            return (
                <div>
                    <h4>{strings.reports_no_data_for_selected_time_period}</h4>
                </div>
            );
        }

        if (this.props.historyUrlOverride) {
            finalcards.forEach(c => c._historyUrlOverride = this.props.historyUrlOverride);
        }

        finalcards.sort( (a, b) => {

                if(a['FactSegment2.startTime'] < b['FactSegment2.startTime']) return -1;
                if(a['FactSegment2.startTime'] > b['FactSegment2.startTime']) return 1;
                return 0;
            });

        if (!this.state.exportURI && finalcards.length > 0) {
            this.generateCSV(columns, finalcards);
        }

        return (
            <div>
                <ReactTable
                    filterable={true}
                    defaultFilterMethod={(filter, row) => {
                        if (row._nestingLevel > 0) return true;
                        if( String(row[filter.id]).toLowerCase().includes(String(filter.value).trim().toLowerCase()) )
                            return true;
                        // Now look at the subrows
                        if(row._subRows && row._subRows.length > 0)
                        {
                            for(var i = 0; i < row._subRows.length; i++)
                            {
                                if( String(row._subRows[i][filter.id]).toLowerCase().includes(String(filter.value).trim().toLowerCase()) )
                                    return true;

                            }
                        }
                    }}
                    data = { finalcards }
                    columns = {columns}
                    noDataText={strings.reports_no_data_for_selected_time_period}
                    showPagination = {false}
                    defaultPageSize = {Number.MAX_SAFE_INTEGER} // RAV-1942, step one (effectively "set the page size to the number of rows" returned from the database)
                    minRows = {0} /* 0, do not show empty filler rows */
                    pivotBy = { pivots }
                    defaultSorted={[
                        ...sort,
                        { id: 'FactSegment2.startTime',
                          desc: false
                        }
                    ]}
                    getTrProps={(state, rowInfo, column) => {
                        if(rowInfo && rowInfo.aggregated)
                            return { className: '-rollup' };
                        return { className: '-padRow'};
                    }}
                />
                <div className='text-right mt-1'>
                    <a
                        className='btn btn-outline-blue btn-sm'
                        download="stop-report.csv"
                        id="export-link"
                        href={this.state.exportURI || '#'}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {this.state.exportURI ? strings.action_export_CSV : strings.generate_CSV}
                    </a>
                </div>
            </div>
        );
    }
}

const ConnectedReportTable = connect()(ReportTable);

ReportsSection.propTypes = {
    selectedDateRange: PropTypes.instanceOf(Array).isRequired,
    unitOfMeasure: PropTypes.string.isRequired,
}

export default ReportsSection;
